import React, { useState, useEffect } from 'react'

import Section1 from './Sections/Section1'
import Section2 from './Sections/Section2'
import Section3 from './Sections/Section3'
import Section4 from './Sections/Section4'
import Section5 from './Sections/Section5'
import Section6 from './Sections/Section6'
import Section7 from './Sections/Section7'
import Section8 from './Sections/Section8'
import Section9 from './Sections/Section9'
import LandingNavBar from 'components/navbar/NavBar'
// import Footer from 'components/Footer'
import LandingPageModal from 'components/Modal'
import LandingFooter from 'components/Footer/landingFooter'

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [activeSection, setActiveSection] = useState('section2')
  const [isModalOpen, setIsModalOpen] = useState(true)

  // ✅ Initialize AOS on mount
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1191)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const renderSections = () => {
    if (!isMobile) {
      return (
        <>
          <div>
            <Section2 />
          </div>
          <div>
            <Section3 />
          </div>
        </>
      )
    } else {
      return (
        <div className="mobile-switch-container">
          <div className="mobile-switch-buttons">
            <button
              className={`mobile-switch-btn ${activeSection === 'section2' ? 'active' : ''}`}
              onClick={() => setActiveSection('section2')}
            >
              Student
            </button>
            <button
              className={`mobile-switch-btn ${activeSection === 'section3' ? 'active' : ''}`}
              onClick={() => setActiveSection('section3')}
            >
              Tutor
            </button>
          </div>

          <div className="mobile-switch-content">
            {activeSection === 'section2' ? (
              <div>
                <Section2 />
              </div>
            ) : (
              <div>
                <Section3 />
              </div>
            )}
          </div>
        </div>
      )
    }
  }

  return (
    <div className="bg-white">
      {/* {isModalOpen && <LandingPageModal onClose={() => setIsModalOpen(false)} />} */}
      <LandingNavBar />

      <Section1 />

      {renderSections()}

      <Section4 />

      <Section5 />

      <Section6 />

      <Section7 />

      <Section8 />

      <Section9 />

      <LandingFooter />
    </div>
  )
}

export default HomePage
